import { render, staticRenderFns } from "./FeedbackDialog.vue?vue&type=template&id=4f02e646"
import script from "./FeedbackDialog.vue?vue&type=script&lang=js"
export * from "./FeedbackDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f02e646')) {
      api.createRecord('4f02e646', component.options)
    } else {
      api.reload('4f02e646', component.options)
    }
    module.hot.accept("./FeedbackDialog.vue?vue&type=template&id=4f02e646", function () {
      api.rerender('4f02e646', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FeedbackDialog.vue"
export default component.exports